module.exports = __webpack_public_path__ + "media/images/ponce_battery-d084a265.png";